// frontend/src/components/TokenCountGauge.jsx
import React from "react";

export default function TokenCountGauge({ value = 0, max = 500 }) {
  const radius = 40;
  const stroke = 8;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;

  // Clamp valeur
  const safeValue = Math.min(value, max);
  const strokeDashoffset =
    circumference - (safeValue / max) * circumference;

  return (
    <div style={{ textAlign: "center" }}>
      <svg height={radius * 2} width={radius * 2}>
        <circle
          stroke="#333"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="#ffd600"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + " " + circumference}
          style={{ strokeDashoffset, transition: "stroke-dashoffset 0.3s" }}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
      <div style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#ffd600" }}>
        {value}
      </div>
    </div>
  );
}
